module.exports = __webpack_public_path__ + "static/media/good2swim-logo.3b9d1c21.png";